import React from "react";
import { makeStyles } from 'tss-react/mui';
import { CircularProgress } from "@mui/material";

const useStyles = makeStyles()({
    mainContainer: {
        backgroundColor: "transparent",
        border: "2px solid black",
        borderRadius: 30,
        padding: "50px",
        width: "min-content",
        textAlign: "center",
    },
    progress: {
        margin: "auto",
        width: "50%",
    },
});

export function LoadingBox(props: { message: string }) {
    const { classes } = useStyles();

    return (
        <div className={classes.mainContainer}>
            <CircularProgress size={48} className={classes.progress} />
            <span>{props.message}</span>
        </div>
    );
}
